// extracted by css-extract-rspack-plugin
export default {"wrapper":"_66b0e927","clickable":"_c308c410","borderCircle":"_7b4154aa"};